const IconDryer = () => {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5878_125328)">
                <path
                    d="M27.5 5.33594H10V14.3359H27.5C28.3284 14.3359 29 13.6644 29 12.8359V6.83594C29 6.00751 28.3284 5.33594 27.5 5.33594Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 24.8359L25 14.3359L20 14.3359L20 24.8359C20 26.2166 21.1193 27.3359 22.5 27.3359C23.8807 27.3359 25 26.2166 25 24.8359Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4 12.3359V7.33594H5.6459C5.87877 7.33594 6.10844 7.28172 6.31672 7.17758L10 5.33594V14.3359L6.31672 12.4943C6.10844 12.3902 5.87877 12.3359 5.6459 12.3359H4Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M20 19.3359H22" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 22.3359H22" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_5878_125328">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.335449)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconDryer;
